module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/download-8a9a4d409591bdb3a0e49326c0b39bcb.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/download.svg
// module id = zb6g
// module chunks = 24